import {
    Component, Prop, Mixins,
} from 'vue-property-decorator';
import CommonProps from '@components/shared/mixins/props';

/**
 * PageContent Props
 */
@Component
class Props extends Mixins(CommonProps) {}

export default Props;
